import {Stack, Transition} from "@mantine/core";
import classes from "./ChatSplashView.module.css";
import {useEffect, useMemo, useState} from "react";
import {chatApi} from "../chatApi";
import {useSearchParams} from "react-router-dom";
import AskAboutAnimation from "./AskAboutAnimation";
import Footer from "./Footer";
import {SplashInput} from "./SplashInput";
import {RecentSearches} from "./RecentSearches";
import {RecentThreads} from "./RecentThreads";
import {useSplashSubmit} from "../hooks/useSplashSubmit";
import {parseApiDate} from "../../../utils/dateUtils";

export function ChatSplashView() {
    const initData = chatApi.endpoints.getInit.useQuery({threadCount: 3});
    const recentSearches = initData.data?.recentTopics || [];
    const threadsData = initData.data?.threads || [];

    const sortedThreads = useMemo(() => {
        if (!threadsData?.items) return [];
        return [...threadsData.items].sort(
            (a, b) =>
                parseApiDate(b.lastUpdated).getTime() -
                parseApiDate(a.lastUpdated).getTime()
        );
    }, [threadsData]);

    const [value, setValue] = useState("");
    const handleSendMessage = useSplashSubmit();

    // If the query parameter is set, send the message and clear the parameter
    const [searchParams, setSearchParams] = useSearchParams();
    const initialQuery = searchParams.get("q");
    useEffect(() => {
        if (initialQuery) {
            searchParams.delete("q");
            handleSendMessage(decodeURIComponent(initialQuery));
        }
    }, [initialQuery, handleSendMessage, setSearchParams, searchParams]);

    return (
        <>
            <Stack className={classes.chatContainer}>
                <Stack gap={0} className={classes.frontPageContainer}>
                    <Stack className={classes.headerSection}>
                        <Stack className={classes.headerContent}>
                            <AskAboutAnimation />
                            <SplashInput
                                value={value}
                                onSendMessage={handleSendMessage}
                                onValueChange={setValue}
                            />
                            <Transition
                                mounted={sortedThreads.length > 0}
                                transition="fade"
                                duration={300}
                            >
                                {(styles) => (
                                    <div style={styles}>
                                        <RecentThreads data={sortedThreads} />
                                    </div>
                                )}
                            </Transition>
                            <Transition
                                mounted={
                                    recentSearches && recentSearches.length > 0
                                }
                                transition="fade"
                                duration={300}
                            >
                                {(styles) => (
                                    <div style={styles}>
                                        <RecentSearches data={recentSearches} />
                                    </div>
                                )}
                            </Transition>
                        </Stack>
                    </Stack>
                    <Footer variant={"detailed"} />
                </Stack>
            </Stack>
        </>
    );
}
